//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import filters from "@/filters";

export default {
  name: "ImagesView",
  created() {},
  props: {
    post: {
      type: Object,
      default: null
    },
    isMultiRows: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  },
  methods: {
    processImage: filters.processImage
  },
  computed: {
    isSingleImage() {
      return !this.post.images || this.post.images.length <= 1;
    },
    validImages() {
      return (this.post.images || []).filter(
        image => image.url && !image.url.includes(".html")
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/post/ImagesView.vue